export class TypeDeSorts {
    public static IdCompetenceBoucherie = 69;
    public static IdCompetenceSorcellerie = 68;
    public static IdCompetencePharmacologie = 67;
    
    public values: Map<number, string> = new Map<number, string>([
        [0, "Boucherie"],
        [1, "Art"],
        [2, "Rituel"],
        [3, "Pharmacologie"],
    ]);
    
}